import React from 'react';
import { Box } from '@chakra-ui/react';
import ProgramStructureV3 from '../ProgramStructureV3';
import ProgramStepsV5 from '../ProgramStepsV5';
import PageSectionV5 from '../PageSectionV5';
import ProgramFee from '../ProgramFee';
import EnrollSection from '../EnrollSection';

interface OnlineTabProps {
  sectionId?: string;
  section: any;
  pageData: any;
  pageName?: string;
  prgData?: any;
  scholarshipsRef?: any;
  lang?: string;
  region?: string;
  sectionContent?: any;
  couponData?: any;
  context?: any;
  setContext?: (context: any) => void;
  scrollRef?: React.RefObject<HTMLElement>;
  programFeeContent?: any;
  ieoEnrollSectionContent?: any;
}

const OnlineTab: React.FC<OnlineTabProps> = ({
  sectionId,
  section,
  pageData,
  pageName,
  prgData,
  scholarshipsRef,
  couponData,
  context,
  setContext,
  scrollRef,
  programFeeContent,
  ieoEnrollSectionContent,
  region,
  lang,
}) => {
  return (
    <Box mx={{ base: 8, md: 0 }} pb={{ base: '40px', md: '100px' }}>
      <ProgramStructureV3
        lang={lang}
        region={region}
        sectionContent={section}
        pageData={pageData}
        pageName={pageName}
        prgData={prgData}
      />

      <ProgramStepsV5
        lang={lang}
        region={region}
        sectionContent={section}
        pageData={pageData}
        pageName={pageName}
        prgData={prgData}
      />

      <PageSectionV5 lang={lang} sectionContent={section} />
      <ProgramFee
        sectionContent={programFeeContent}
        lang={lang}
        region={region}
        pageData={pageData}
        prgData={prgData}
        scholarshipsRef={scholarshipsRef}
      />

      <EnrollSection
        sectionContent={ieoEnrollSectionContent}
        lang={lang}
        region={region}
        prgData={prgData}
        couponData={couponData}
        pageData={pageData}
        context={context}
        pageName={pageName}
        setContext={setContext}
        scrollRef={scrollRef}
      />
    </Box>
  );
};

export default OnlineTab;
